import useAuthStore from '../store/authStore';
import { API_CONFIG } from '../config/api.config';

interface AuditLogData {
  user_id: string;
  action: string;
  description: string;
  company: string;
}

export async function logAuditEvent(action: string, description: string, userData?: any): Promise<void> {
  try {
    let user = userData;

    if (!user) {
      const zustandUser = useAuthStore.getState().user;
      user = zustandUser;

      if (!user) {
        try {
          const { store } = await import('../store/store');
          const state = store.getState();
          user = state.auth.user;
        } catch (error) {
          console.error('Error accessing Redux store:', error);
        }
      }
    }

    if (!user) {
      return;
    }

    const userId = user.id?.toString() || user.userId?.toString() || user.email || 'unknown';

    const auditData: AuditLogData = {
      user_id: userId,
      action,
      description,
      company: user.companyName || 'unknown'
    };

    const response = await fetch(`${API_CONFIG.baseURL}/audit-logs`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Origin: typeof window !== 'undefined' ? window.location.origin : '',
        'x-company-id': user.companyID?.toString() || '',
        'x-company-name': user.companyName || 'unknown',
      },
      body: JSON.stringify(auditData),
    });

    if (!response.ok) {
      console.error('Failed to log audit event:', response.statusText);
    }
  } catch (error) {
    console.error('Error logging audit event:', error);
  }
}

// Predefined audit actions for consistency
export const AUDIT_ACTIONS = {
  // Sensor actions
  SENSOR_CALIBRATE: 'sensor_calibrate',
  SENSOR_CALIBRATE_CLEAR: 'sensor_calibrate_clear',
  SENSOR_SETREF: 'sensor_setref',
  SENSOR_SETREF_CLEAR: 'sensor_setref_clear',
  SENSOR_EDIT: 'sensor_edit',
  SENSOR_DELETE: 'sensor_delete',
  SENSOR_CREATE: 'sensor_create',
  SENSOR_SET_OUT_OF_SERVICE: 'sensor_set_out_of_service',
  SENSOR_RETURN_TO_SERVICE: 'sensor_return_to_service',
  SENSOR_PROBE_TYPE_CHANGE: 'sensor_probe_type_change',
  
  // User actions
  USER_CREATE: 'user_create',
  USER_EDIT: 'user_edit',
  USER_DELETE: 'user_delete',
  
  // Zone actions
  ZONE_CREATE: 'zone_create',
  ZONE_EDIT: 'zone_edit',
  ZONE_DELETE: 'zone_delete',
  
  // Alarm actions
  ALARM_ACKNOWLEDGE: 'alarm_acknowledge',
  
  // Authentication
  USER_LOGIN: 'user_login',
  USER_LOGOUT: 'user_logout',
  
  // Settings
  SETTINGS_UPDATE: 'settings_update',

  // Notifications (written server-side by the alert dispatcher)
  EMAIL_SENT: 'email_sent',
  SMS_SENT: 'sms_sent',
} as const; 